{
  "features-debit-card-no-ssn": {
    "meta": {
      "title": "Tarjeta de débito Visa® sin SSN - MAJORITY",
      "description": "Obtén una Tarjeta de débito Visa MAJORITY gratis sin importar si tienes o no un SSN y ahorra con cashback, descuentos, sin cargos ocultos y más."
    },
    "hero": {
      "title": "Tarjeta de débito Visa® sin SSN",
      "body": "Obtén una Tarjeta de débito Visa MAJORITY gratis sin importar si tienes o no un SSN y ahorra con cashback, descuentos, sin cargos ocultos y más.",
      "cta": "Comenzar",
      "circle": "Sin necesidad de SSN"
    },
    "no_ssn_content_box": {
      "tagline": "Tarjeta de débito Visa®",
      "title": "Obtén una Tarjeta de débito gratis, sin necesidad de SSN",
      "body": "Independientemente del estatus migratorio, todos merecen acceso a servicios financieros básicos. Es por eso que nos asociamos con Axiom Bank, N.A. para ofrecer una cuenta y una Tarjeta de débito Visa® gratis incluso sin un SSN. Simplemente verifica tu identidad con una ID emitida por el gobierno, como un pasaporte o matrícula consular.",
      "canvas": "No tienes SSN, no hay problema",
      "cta": "Comenzar"
    },
    "cashback": {
      "title": "Obtén cashback por apoyar a establecimientos locales",
      "body": "Desliza con orgullo y ahorra al usar tu Tarjeta de débito Visa MAJORITY. Nos asociamos con empresas propiedad de migrantes para brindarte cashback y descuentos en tus supermercados, restaurantes y otros lugares locales favoritos. Además, ofrecemos muchas ofertas de cashback en comercios minoristas nacionales.",
      "cta": "Ver los descuentos"
    }
  }
  
}